import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledCoverImage = styled.div<{ isVisible?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	${addTransition()}

	${(p) =>
		p.isVisible
			? css`
					opacity: 1;
					//transform: translateY(0);
			  `
			: css`
					opacity: 0;
					//transform: translate(100%);
			  `}
`;
